module.exports = __webpack_public_path__ + "img/circle.cd1a10d8.svg";